import { gql } from '@apollo/client';

export const DOCTOR_APPOINTMENT_QUERY = gql`
  query doctorAppointmentByDateWithPractioners($startDate: DateTime, $endDate: DateTime, $excludeCancelled: Boolean) {
    doctorAppointmentsByDateWithPractitioners(
      startDate: $startDate
      endDate: $endDate
      excludeCancelled: $excludeCancelled
    ) {
      id
      relatedPractitioners {
        practitioner {
          id
          firstName
          lastName
        }
        relationshipType
      }
      practitioner {
        id
        firstName
        lastName
      }
      appointment {
        id
        patient {
          id
          fullName
          firstName
          middleName
          preferredName
          lastName
          ida
          dob
          gender
          address {
            id
            formattedAddress
          }
          photoUrl
        }
        location {
          id
          name
        }
        startTime
        duration
        comment
        activity
        statusAbbreviation
        appointmentType
        description
        shortDescription
        department {
          id
          alias
        }
      }
    }
  }
`;

export const DOCTOR_APPOINTMENT_QUEUE_STATUS_QUERY = gql`
  query getAppointmentQueueStatus($appointmentIds: [ID]) {
    getAppointmentQueueStatus(appointmentIds: $appointmentIds) {
      id
      status
    }
  }
`;
